import { render, staticRenderFns } from "./pvOrderDetail.vue?vue&type=template&id=bfc5b076&scoped=true"
import script from "./pvOrderDetail.vue?vue&type=script&lang=js"
export * from "./pvOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./pvOrderDetail.vue?vue&type=style&index=0&id=bfc5b076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc5b076",
  null
  
)

export default component.exports